import { gql } from '@apollo/client';

// TODO: Split to Fragments
export const GET_USER_WITH_ACCOUNTS = gql`
  query {
    userWithAccounts {
      has_limited_accounts
      cart_items_with_cards {
        amount
        card_id
        name
        image
        ticker
      }
      user {
        uuid
        braze_id
        email
        first_name
        last_name
        name {
          firstName
          lastName
        }
        web_reg_version
        restricted_reason
        created_at
        stash_bank_plastic_deposits {
          amount
        }
        phone_number_verification {
          phone_number
          verified
        }
      }
      profile {
        date_of_birth
        citizenship_country
        birth_country
        permanent_resident
        visa_type
        visa_expiration_date
        birthdate {
          day
          month
          year
          date
        }
        nationality {
          citizenshipCountry
          birthCountry
          permanentResident
          visa {
            type
            expirationDate
          }
        }
        home_street_address
        home_city
        home_state
        home_postal_code
        home_country
        phone_number
        phone_number_type
        encrypted_social_security_number
        identifier
      }
      accounts {
        id
        type
        title
        type_title
        e_signature_agreed_at
        bank_account {
          bank_name
          account_name
          masked_account_number
          aasm_state
        }
        auto_stash {
          frequency
          funding_source
          total_allocated_amount
        }
      }
      funding_sources {
        description
        id
        provider_type
        provider_uuid
      }
      investor_application {
        employment_status
        employer
        position_employed
        federal_tax_bracket_percent
        risk_tolerance
        time_horizon
        liquidity_needs
        investment_objective
        investment_experience
        is_control_person
        company_symbols
        is_politically_exposed
        immediate_family
        political_organization
        is_affiliated_exchange_or_finra
        firm_name
        annual_income_range
        liquid_net_worth_range
        total_net_worth_range
        dividend_reinvestment
        filing_status
        tax_withholding_percent
        household_income_bracket
        marital_status
        children_under_18
        own_a_home
        investing_experience
        have_a_retirement_account
        paying_student_loans
        children_under_eighteen
      }
      trusted_contact {
        id
        user_id
        opted_out_at
      }
      active_platform_tier {
        platform_tier {
          product_types
          banner_tooltip {
            body
            title
          }
          detail
          funding_source
          price {
            amount {
              currency
              value
            }
            frequency
            tooltip {
              body
              title
            }
          }
          sections {
            features {
              enabled
              name
              tooltip {
                body
                title
              }
            }
            title
          }
          subtitle {
            name
            tooltip {
              body
              title
            }
          }
          title
          type
        }
      }
      eligible_account_types
    }
  }
`;
